import { formatDistanceToNow } from "date-fns";
import { sv, enGB } from "date-fns/locale";
import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Avatar, Text } from "src/components";
import { theme } from "src/config";
import { Item, Log, User } from "src/models";
import { DataType, IItem } from "src/types";
import styled from "styled-components";
import { LogText } from ".";

export type LogEntryProps = {
  user?:     User;
  log:       Log;
  item:      Item<IItem>;
  itemType:  DataType;
};

export const LogEntry = observer((props: LogEntryProps) => {
  const { user, log } = props;
  const { t, i18n } = useTranslation();
  const locale = i18n.language == 'sv' ? sv : enGB;

  return (
    <ActivityListItem key={log.id}>
      <AvatarContainer>
        <Avatar
          size     = "medium"
          image    = {user?.getAvatar}
          initials = {user?.getInitials}
        />
      </AvatarContainer>
      <ActivityContainer>
        <Text weight = "bold" size = "default">
          {user?.getFullName || t("deleted_user")}
        </Text>
        <Text size = "small" as = "pre">
          <LogText log={log} />
        </Text>
        <Text
          size  = "xxsmall"
          color = {theme.color.grayDark}
          as    = "span"
          title = {log.created_at.toISOString()}
        >
          {formatDistanceToNow(log.created_at, {
            addSuffix: true,
            locale
          })}
        </Text>
      </ActivityContainer>
    </ActivityListItem>
  );
});


const ActivityListItem = styled.div`
  display:        flex;
  flex-direction: row;
  align-items:    center;
  padding:        0.5rem 0.5rem;
`;

const AvatarContainer = styled.div`
  width: fit-content;
`;

const ActivityContainer = styled.div`
  display:        flex;
  flex-direction: column;
  margin-left:    1rem;
  padding-bottom: 1rem;
  border-bottom:  1px solid ${theme.color.grayLight};
  width:          100%;
`;